// JS
import '../../custom/js/custom/index';

// Base SCSS
import '../../custom/scss/common/base.scss';
import '../../custom/scss/custom/layout.scss';

// Components
import '~/src/custom/scss/custom/components/error/error.scss';
import '~/src/custom/scss/custom/components/error/not-found.scss';

// import Vue App
import Vue from 'vue';
import VueApp from '~/src/custom/vue/apps/search-bar.js';
import App from '~/src/custom/vue/apps/containers/search-app.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#search-typeahead-app');